import { getActiveResource } from 'helpers/modalHelpers';

// Get values from Redux (fieldReducer or modalReducer)
export const getField = (state, { inModal, predicate }) => {
  if (inModal) {
    return getActiveResource(state)?.fields[predicate];
  } else {
    return state.field.fields[predicate];
  }
};

// Needed for fields which add/link resources
export const getParentUri = (state) => {
  if (!state.modal.showing) {
    return state.object.uri;
  } else {
    const resource = getActiveResource(state);
    // Can be null when previous not created yet.
    return resource?.uri || resource?.template || null;
  }
};

// When serializing Resource JSON in Java, 
// field with modeConstraint needs to know what view
// we are using to filter.
export const getViewMode = (state) => {
  return state.view.view?.view?.toUpperCase();
};

// Returns deep copy of values for originalValues
export const getFieldValuesCopy = fields => {
  const values = {};

  Object.entries(fields).forEach(([predicate, field]) => {
    values[predicate] = JSON.parse(JSON.stringify(field.values));
  });

  return values;
}